// extracted by mini-css-extract-plugin
export default {"categoryRefinementLinks":"categoryRefinementLinks_M8OP8"};